<script setup lang="ts">
const { t } = useI18n();

const route = useRoute();

const isCart = computed(() => {
  return route.name === 'cart';
});

const dataStore = useDataStore();
const DB = useDbStore();

const logout = async () => {
  return await DB.logout()
    .then((e) => {
      reloadNuxtApp();
      return e;
    });
};

// TODO: add call backs against href
const links = [
  { href: '/account/dashboard', label: 'Personal_area' },
  { cb: logout, label: 'Log_out' },
];

const isOpen = ref(false);
const toggle = () => {
  isOpen.value = !isOpen.value;
};

const showLoginAsPopup = ref(false);

const goLogin = async () => {
  if (isCart.value) {
    showLoginAsPopup.value = true;
  }
  else {
    navigateTo('/login', {
      redirectCode: 401,
    });
  }
};
</script>

<template>
  <div
    v-if="!dataStore.user"
    class="flex gap-4"
  >
    <ButtonLevel
      type="2"
      :title="t('Sign_up')"
      @click="navigateTo('/sign-up')"
    />
    <ButtonLevel
      type="3"
      :title="t('Log_in')"
      @click="goLogin"
    />
    <LoginPopup
      v-if="showLoginAsPopup"
      show-as="popup"
      @click-close="showLoginAsPopup = false"
    />
  </div>
  <div
    v-else
    class="flex items-center select-none cursor-pointer"
  >
    <DropMenu
      class="max-lg:hidden"
      :links="links"
      side="right"
    >
      <template #default>
        <AvatarCircle
          :name="dataStore.user.name"
          :avatar="dataStore.user.avatar"
        />
      </template>
    </DropMenu>
    <div class="lg:hidden">
      <div
        class="flex items-center gap-4"
        @click="toggle"
      >
        <AvatarCircle
          :name="dataStore.user.name"
          :avatar="dataStore.user.avatar"
        />
        <ButtonLevel
          class="max-md:hidden lg:hidden"
          type="4"
          :title="t('Profile_settings').toUpperCase()"
        />
      </div>

      <template v-if="isOpen">
        <div class="pl-2 py-2">
          <ButtonLevel
            type="4"
            :title="t('Personal_area')"
            @click="navigateTo('/account/dashboard')"
          />
        </div>

        <div class="pl-2 py-2">
          <ButtonLevel
            type="4"
            :title="t('Log_out')"
            @click="logout"
          />
        </div>
        <!--        <div class="bg-gray-300 w-full h-[1px]" /> -->
      </template>
    </div>
  </div>
</template>
